import { useCallback, useEffect, useState } from "react"

const HISTORY_KEY = "math-solver-history"
const MAX = 3

export function useHistory() {
  const [history, setHistory] = useState([])

  useEffect(() => {
    try {
      chrome.storage.sync
        .get(HISTORY_KEY)
        .then((result) => {
          const stored = result[HISTORY_KEY]
          if (Array.isArray(stored)) {
            console.log("[EqSolve history] loaded", stored)
            setHistory(stored)
          }
        })
        .catch(() => {})
    } catch {}
  }, [])

  const push = useCallback((entry) => {
    setHistory((current) => {
      const key = `${entry.equation}|${entry.region ?? ""}|${entry.level ?? ""}`
      const filtered = current.filter((item) => `${item.equation}|${item.region ?? ""}|${item.level ?? ""}` !== key)
      const next = [entry, ...filtered].slice(0, MAX)
      console.log("[EqSolve history] push", {
        equation: entry.equation,
        region: entry.region,
        level: entry.level,
        size: next.length,
      })
      try {
        chrome.storage.sync.set({ [HISTORY_KEY]: next })
      } catch {}
      return next
    })
  }, [])

  const clear = useCallback(() => {
    console.log("[EqSolve history] clear")
    setHistory([])
    try {
      chrome.storage.sync.remove(HISTORY_KEY)
    } catch {}
  }, [])

  return { history, push, clear }
}
